export default "__VITE_ASSET__f87bde2e__"